import { useMutation, useQueryClient } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { DocumentsApiService } from 'features/document-report/api/documents-api.service';
import { DocumentQueryKeys } from 'features/document-report/use-cases/query-keys';

const { DeleteDocument } = DocumentsApiService();

export const useDeleteDocument = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: {
      LoggedInUserId: string;
      DocumentId: string;
      IsAdmin: boolean;
    }) => DeleteDocument(payload),
    onError: (error: unknown) => {
      const uiMessage = handleError(error);
      message.error(uiMessage);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: DocumentQueryKeys.all,
      });
    },
  });
};
